import React, { useEffect, useState } from "react";
import { withTranslation } from "react-i18next";
import Button from "../../components/Button";
import Page from "../../components/Page";
import { Checkbox, Select, Slider } from "@mantine/core";
import "./styles.css";
import JobCard from "./JobCard";
import ads from "../../assets/home.gif";
import { backendUrl } from "../../constants";
import { useNavigate, useParams } from "react-router-dom";

const Index = ({ t }) => {
  const navigate = useNavigate();
  let userData = JSON.parse(localStorage.getItem("userData"));
  const { keyword, location } = useParams();
  const data = [
    { label: "Bender Bending Rodríguez", value: "Bender Bending Rodríguez" },
    { label: "Bender", value: "Bender" },
  ];

  // const [distance, setDistance] = useState("5");
  const [edu, setEdu] = useState([]);
  const [exp, setExp] = useState([]);
  const [loc, setLoc] = useState([]);
  const [emp, setEmp] = useState([]);
  const [jobs, setJobs] = useState([]);
  const [filters, setFilters] = useState({});

  const MARKS = [
    { value: 5, label: "5 miles" },
    { value: 10, label: "10 miles" },
    { value: 15, label: "15 miles" },
    { value: 20, label: "20 miles" },
    { value: 25, label: "25 miles" },
  ];

  //location
  useEffect(() => {
    const options = {
      method: "GET",
    };

    fetch(`${backendUrl}empLocation/listEmpLocation`, options)
      .then((response) => response.json())
      .then((response) => {
        response.data.map((obj) => {
          let a = { value: obj?._id, label: obj?.locationName };
          setLoc((loc) => [...loc, a]);
        });
      })
      .catch((err) => console.error(err));
  }, []);

  //education
  useEffect(() => {
    const options = {
      method: "GET",
    };

    fetch(`${backendUrl}lookup/getLookupByType/education`, options)
      .then((response) => response.json())
      .then((response) => {
        response.data.map((obj) => {
          let a = { value: obj?._id, label: obj?.lookupName };
          setEdu((edu) => [...edu, a]);
        });
      })
      .catch((err) => console.error(err));
  }, []);

  //experience
  useEffect(() => {
    const options = {
      method: "GET",
    };

    fetch(`${backendUrl}lookup/getLookupByType/experience`, options)
      .then((response) => response.json())
      .then((response) => {
        response.data.map((obj) => {
          let a = { value: obj?._id, label: obj?.lookupName };
          setExp((exp) => [...exp, a]);
        });
      })
      .catch((err) => console.error(err));
  }, []);

  //employment type
  useEffect(() => {
    const options = {
      method: "GET",
    };

    fetch(`${backendUrl}lookup/getLookupByType/jobType`, options)
      .then((response) => response.json())
      .then((response) => {
        response.data.map((obj) => {
          let a = { value: obj?._id, label: obj?.lookupName };
          setEmp((emp) => [...emp, a]);
        });
      })
      .catch((err) => console.error(err));
  }, []);

  //filters
  useEffect(() => {
    setJobs([]);
    let options;
    if (keyword || location) {
      options = {
        method: "POST",
        headers: {
          Accept: "application/json",
          "content-type": "application/json",
        },
        body: JSON.stringify({ jobTitle: keyword, empLocation: location }),
      };
    } else {
      options = {
        method: "POST",
        headers: {
          Accept: "application/json",
          "content-type": "application/json",
        },
        body: JSON.stringify(filters),
      };
    }
    fetch(`${backendUrl}user/searchJobs`, options)
      .then((response) => response.json())
      .then((response) => {
        response.data.map((obj) => {
          let applied = false;
          obj.appliedCandidates.map((obj2) => {
            if (obj2.user === userData.id) {
              applied = true;
            }
          });
          if (!applied) {
            let a = {
              key: obj?._id,
              appliedCandidates: obj?.appliedCandidates,
              title: obj?.jobTitle,
              logo: obj?.attachedFiles[0]?.filePath,
              company: obj?.createdBy?.companyName,
              description: obj?.jobDescription,
              location: obj?.empLocation?.city,
              date: obj?.createdDate,
              remote: obj?.remotely,
            };
            setJobs((jobs) => [...jobs, a]);
          }
        });
      })
      .catch((err) => console.error(err));
  }, [filters, keyword, location, userData?.id]);

  const clearSearch = () => {
    if (location || keyword) {
      navigate("/search");
    }
    window.location.reload();
  };
  return (
    <Page className="landing-page">
      <div className="searchMain1">
        <h2 className="text-dark mb-0 mt-2">Search Jobs</h2>
        <div className="searchMain">
          <div className="filters">
            <Select
              label="Job Search"
              placeholder="Keyword, Title or Company"
              data={data}
              searchable
              value={keyword}
              onChange={(v) =>
                setFilters((filters) => ({ ...filters, jobTitle: v }))
              }
              creatable
              maxDropdownHeight={400}
              getCreateLabel={(query) => `${query}`}
              filter={(value, item) =>
                item.label.toLowerCase().includes(value.toLowerCase().trim())
              }
            />
            <Select
              label="Location"
              placeholder="Location..."
              data={loc}
              searchable
              creatable
              maxDropdownHeight={400}
              getCreateLabel={(query) => `${query}`}
              onChange={(v) =>
                setFilters((filters) => ({ ...filters, empLocation: v }))
              }
              filter={(value, item) =>
                item.label.toLowerCase().includes(value.toLowerCase().trim())
              }
            />

            {filters.empLocation && (
              <>
                <h6 className="mt-2">With in {filters.distance} miles</h6>
                <Slider
                  label={(val) =>
                    MARKS.find((mark) => mark.value === val).label
                  }
                  defaultValue={0}
                  step={5}
                  min={5}
                  max={25}
                  color="red"
                  // onChange={setDistance}
                  onChange={(v) =>
                    setFilters((filters) => ({ ...filters, distance: v }))
                  }
                  marks={MARKS}
                  styles={{
                    markLabel: { display: "none" },
                    root: { marginBottom: "10px" },
                  }}
                />
              </>
            )}
            <Select
              label="Education"
              placeholder="Any..."
              onChange={(v) =>
                setFilters((filters) => ({ ...filters, education: v }))
              }
              data={edu}
              maxDropdownHeight={400}
              nothingFound="Nothing here"
            />
            <Select
              label="Experience"
              placeholder="Any..."
              onChange={(v) =>
                setFilters((filters) => ({ ...filters, experience: v }))
              }
              data={exp}
              maxDropdownHeight={400}
              nothingFound="Nothing here"
              filter={(value, item) =>
                item.label.toLowerCase().includes(value.toLowerCase().trim()) ||
                item.description
                  .toLowerCase()
                  .includes(value.toLowerCase().trim())
              }
            />
            <Checkbox
              label="Remote work positions only."
              color="red"
              onChange={(v) =>
                setFilters((filters) => ({
                  ...filters,
                  remote: v.target.checked,
                }))
              }
              className="mt-2"
            />
            <Checkbox.Group
              label="Job Type"
              size="xs"
              onChange={(v) =>
                setFilters((filters) => ({
                  ...filters,
                  employmentType: v.join(","),
                }))
              }
            >
              <div className="d-flex w-100 row justify-content-between">
                {emp &&
                  emp.map((obj, key) => (
                    <Checkbox
                      classNames="col-md-6"
                      key={key}
                      value={obj?.value}
                      label={obj?.label}
                      className="w-50"
                      color="red"
                    />
                  ))}
              </div>
            </Checkbox.Group>
            <Button
              title={"Clear Search"}
              icon={"cross"}
              primary={true}
              fontWeight="700"
              type="submit"
              onClick={clearSearch}
              width="150px"
              style={{
                display: "flex",
                justifyContent: "space-evenly",
                marginTop: "10px",
              }}
            />
          </div>
          <div className="jobs">
            {jobs.length < 1 ? (
              <h2 className="text-dark text-center">No Jobs Found.</h2>
            ) : (
              jobs?.map((obj, key) => <JobCard data={obj} key={key} />)
            )}
          </div>
          <div className="ads">
            <img src={ads} className="adimage" alt="" />
          </div>
        </div>
      </div>
    </Page>
  );
};

export default withTranslation()(Index);
